// import configEntzy from "components/config/ConfigEntzy";
import { EVENT_MODULES } from "models/Structure";
import { isInteger, getDefaultLargeInt } from "models/Tools";
import { grey, blueGrey, orange, green, red } from "@mui/material/colors";

// fonts and icons
import {
  faFacebook as iconFacebook,
  faInstagram as iconInstagram,
  faThreads as iconThreads,
  faLinkedin as iconLinkedin,
  faXTwitter as iconX,
  faYoutube as iconYoutube,
} from "@fortawesome/free-brands-svg-icons";
// tempoary faux guids for use client side
// when waiting for actual guid from server
const getTempoaryGuid = function () {
  let timestamp, random, tmpGuid;
  timestamp = "tmp" + Date.now();
  random = Math.random().toString(36);
  tmpGuid = "";
  tmpGuid += timestamp.substring(0, 3);
  tmpGuid += timestamp.substring(9, 12);
  tmpGuid += random.substring(10, 12) + "-";
  tmpGuid += timestamp.substring(12, 16) + "-";
  tmpGuid += random.substring(2, 6) + "-";
  tmpGuid += random.substring(6, 10);
  return tmpGuid;
};

const EventModules = function () {
  const moduleStates = {};
  // const ACTIVE_MODULES = EVENT_MODULES.filter((obj) => obj.active);
  for (let module of EVENT_MODULES) {
    moduleStates[module.id] = {
      active: module.active,
      open: false,
      text: {
        runner: {
          title: module.id,
          description: "Runner " + module.id,
          action: "Runner Action",
        },
        rider: {
          title: module.id,
          description: "Rider " + module.id,
          action: "Rider Action",
        },
      },
      counters: {
        runner: {
          header: 0,
          viewer: {
            primary: 0,
            secondary: 0,
          },
        },
        rider: {
          header: 0,
          viewer: {
            primary: 0,
            secondary: 0,
          },
        },
      },
    };
  }
  return moduleStates;
};

const EventDateSetting = function (type) {
  return {
    id: getTempoaryGuid(),
    active: true,
    add: [],
    order: 1,
    tag: "Date",
    subtag: type,
  };
};

const EventTicketSetting = function (type, max, name, price) {
  return {
    id: getTempoaryGuid(),
    active: true,
    min: 10,
    max: max ? max : "Standard",
    order: 1,
    name: name ? name : "Standard",
    price: price ? price : 0,
    tag: "TicketType",
    subtag: type,
  };
};

const EventLimitSetting = function (type, value, active) {
  return {
    id: getTempoaryGuid(),
    active: active ? true : false,
    add: [],
    order: 1,
    tag: "Limit",
    subtag: type,
    max: isInteger(value) ? value : getDefaultLargeInt(),
    unit: type === "notice" ? "days" : "quantity",
  };
};
const EventTriggerSetting = function (type, value, active) {
  return {
    id: getTempoaryGuid(),
    active: active ? true : false,
    add: [],
    order: 1,
    tag: "Trigger",
    subtag: type,
    min: isInteger(value) ? value : getDefaultLargeInt(),
    unit: type === "financial" ? "amount" : "quantity",
  };
};

const EventMain = function () {
  return {
    data: {
      EventId: null,
      UserId: null,
      Url: null,
      Country: null,
      Currency: null,
      Active: true,
      Access: "public",
      Privacy: null,
      Tagline: null,
      Details: null,
      WelcomeDetails: null,
      LaunchPerTicket: false,
      Logo: null,
      TicketTypes: [EventTicketSetting("default", 100)],
      Triggers: [
        EventTriggerSetting("default", 50, true),
        EventTriggerSetting("financial"),
      ],
      Limits: [
        EventLimitSetting("notice", 7, true),
        EventLimitSetting("capacity", 100, true),
      ],
      Ticking: [],
      Dates: [],
      Badges: [],
      Socials: [],
      ImageFrames: EventImageFrames(),
    },
    hydrated: false,
    exploring: false,
    owner: false,
    manager: false,
    pinned: null,
    accessQueued: false,
    accessGranted: false,
    modules: EventModules(),
    moduleSelected: "launchpad",
    moduleHasSelected: {},
    lastDataUpdate: {
      key: null,
      time: null,
    },
    generators: {
      settings: {
        date: EventDateSetting,
        ticket: EventTicketSetting,
        limit: EventLimitSetting,
        trigger: EventTriggerSetting,
      },
    },
  };
};

export const EVENT_CONSTANTS = {
  events: {
    maxNameLength: 30,
    maxTaglineLength: 50,
    maxDetailsLength: 20000,
    minLaunchNotice: 0,
    maxLaunchNotice: 180,
    minLaunchGuests: 1,
    maxLaunchGuests: 10000,
    imageFrameCount: 9,
    imageFrameBase: {
      id: "frame0",
      order: 0,
      active: false,
      tag: "frame",
      path: "none",
    },
    cacheExpiry: 2,
    states: [
      { value: "owner", display: "owner", runner: true },
      { value: "manager", display: "manager", runner: true },
      { value: "ticked", display: "ticked", runner: false },
      { value: "pinned", display: "pinned", runner: false },
      { value: "owner-restored", display: "owner", runner: true },
      { value: "manager-restored", display: "manager", runner: true },
      { value: "restored", display: "restored", runner: false },
    ],
  },
  dates: {
    base: "2022-01-01",
    maxDays: 365,
    maxOffers: 20,
    states: [
      { value: "none", display: "ticking", offer: false, launch: false },
      { value: "initiated", display: "ticking", offer: true, launch: false },
      { value: "ticking", display: "ticking", offer: true, launch: false },
      {
        value: "launchable",
        display: "launchable",
        offer: true,
        launch: false,
      },
      { value: "triggered", display: "launched", offer: false, launch: true },
      { value: "cancelled", display: "cancelled", offer: false, launch: true },
      { value: "expired", display: "expired", offer: false, launch: true },
      { value: "updating", display: "updating", offer: false, launch: false },
    ],
  },
  tickets: {
    maxOffers: 10,
    minGroupSize: 1,
    maxGroupSize: 20,
    activeStates: [
      {
        value: "active",
        display: "active",
        color: green[200],
        textColor: "black",
        active: true,
      },
      {
        value: "inactive",
        display: "inactive",
        color: grey[600],
        textColor: "white",
        active: false,
      },
    ],
    states: [
      {
        value: "initiated",
        display: "ticking",
        color: blueGrey[200],
        textColor: "black",
        offer: true,
        launch: false,
      },
      {
        value: "ticking",
        display: "ticking",
        color: orange[200],
        textColor: "black",
        offer: true,
        launch: false,
      },
      {
        value: "triggered",
        display: "launched",
        color: orange[500],
        textColor: "black",
        offer: false,
        launch: true,
        entry: true,
        ticketReady: true,
      },
      {
        value: "checked",
        display: "entered",
        color: green[500],
        textColor: "black",
        offer: false,
        launch: true,
        entry: true,
        entered: true,
      },
      {
        value: "checked:part",
        display: "part entered",
        color: green[500],
        textColor: "black",
        offer: false,
        launch: true,
        entry: true,
        entered: true,
      },
      {
        value: "incomplete",
        display: "payment issue",
        color: red[200],
        textColor: "black",
        offer: false,
        launch: true,
        entry: false,
        paymentRetry: true,
      },
      {
        value: "refunded",
        display: "refunded",
        color: blueGrey[800],
        textColor: "white",
        offer: false,
        launch: true,
        entry: false,
        ticketRefunded: true,
      },
      {
        value: "refunded:part",
        display: "refunded",
        color: blueGrey[600],
        textColor: "white",
        offer: false,
        launch: true,
        entry: false,
      },
      {
        value: "cancelled",
        display: "cancelled",
        color: grey[600],
        textColor: "white",
        offer: false,
        launch: true,
        entry: false,
      },
      {
        value: "withdrawn",
        display: "withdrawn",
        color: grey[600],
        textColor: "white",
        offer: false,
        launch: false,
        entry: false,
      },
      {
        value: "expired",
        display: "expired",
        color: grey[600],
        textColor: "white",
        offer: false,
        launch: false,
        entry: false,
      },
      {
        value: "updating",
        display: "updating",
        color: grey[0],
        textColor: "black",
        offer: false,
        launch: false,
        entry: false,
      },
    ],
  },
  messaging: {
    rooms: [
      {
        name: "main",
        title: "Main Room",
        description: "Everyone",
      },
      {
        name: "runner",
        title: "Runners Room",
        description: "Only Runners",
      },
      {
        name: "rider",
        title: "Riders Room",
        description: "Only Riders",
      },
      {
        name: "aimain",
        title: "AI Main Room",
        description: "Everyone with AI",
      },
      {
        name: "airunner",
        title: "AI Runners Room",
        description: "Runners with AI",
      },
      {
        name: "airider",
        title: "AI Riders Room",
        description: "Riders with AI",
      },
      {
        name: "desk",
        title: "Front Desk",
        description: "Contact Run Team",
      },
    ],
  },
  pointers: {
    main: "/e/",
    bot: {
      basic: "/=/",
      styled: "/" + String.fromCharCode(9869) + "/",
    },
  },
  meetCategories: [
    // activity based categories
    {
      id: "cuppa",
      title: "Let's have a regular brew",
      tagline: "Get coffee, spill the tea, catch up",
      details:
        "Get together for a regular coffee fix, or to spill the tea over a hot brew.",
      activity: true,
    },
    {
      id: "diy",
      title: "Let's build stuff",
      tagline: "Community projects, DIY, share skills",
      details:
        "Bring a team together when needed to build things in the community.",
      activity: true,
    },
    {
      id: "food",
      title: "Let's have a regular feast",
      tagline: "Dine out, eat in, share meals together",
      details:
        "Head to a restaurant, host dinner parties, get takeouts, or regularly share a feast of a meal together.",
      activity: true,
    },
    {
      id: "drinks",
      title: "Let's get some drinks in",
      tagline: "Drinks somewhere in a pub, bar, garden",
      details:
        "Catch up for regular drinks somewhere in a local pub, a bar, beer garden, or at home.",
      activity: true,
    },
    {
      id: "games",
      title: "Let's do some game nights",
      tagline: "Board games, computer games, card games",
      details:
        "Let's find time to regularly roll the dice, play some cards, or game online.",
      activity: true,
    },
    {
      id: "hibernate",
      title: "Let's just relax indoors",
      tagline: "Relax somewhere inside, do nothing",
      details:
        "An intentional plan to do nothing regularly, hang out indoors, read, relax together.",
      activity: true,
    },
    {
      id: "lunch",
      title: "Let's lunch regularly",
      tagline: "Grab lunch, brunch, daytime snacks",
      details:
        "Find some regular slots in the day for lunch, brunch, all day breakfast, or light bites.",
      activity: true,
    },
    {
      id: "stream",
      title: "Let's have regular screen time",
      tagline: "Catch movies, stream, binge-watch",
      details:
        "Carve out time together to regularly stream the latest movies, shows, or series.",
      activity: true,
    },
    {
      id: "sunseek",
      title: "Let's absorb plenty of vitamin D",
      tagline: "Relax outdoors, parks, beaches",
      details:
        "Enjoy regular outdoor activities together in parks, at the beach, or anything in sun.",
      activity: true,
    },
    {
      id: "shop",
      title: "Let's do regular retail therapy",
      tagline: "Hit the shops, malls, markets",
      details:
        "Get together for regular retail sessions, mall crawls, shopathons.",
      activity: true,
    },
    {
      id: "sport",
      title: "Let's get active regularly",
      tagline: "Play sports, watch sports, train together",
      details:
        "Get active with regular sports sessions, matches, or watch games together.",
      activity: true,
    },
    {
      id: "volunteer",
      title: "Let's do some good regularly",
      tagline: "Community outreach, volunteer work, support",
      details:
        "Offer or join regular support and outreach to people in need in the community.",
      activity: true,
    },
    {
      id: "walk",
      title: "Let's get walking regularly",
      tagline: "Get the steps in, take walks, hikes",
      details:
        "Get moving with regular walks, hikes, or casual strolls in the area.",
      activity: true,
    },
    {
      id: "nights",
      title: "Let's get out for a regular late night",
      tagline: "Club nights, music sessions, all nighters",
      details:
        "Regular late night sessions at a club or anywhere with the right music.",
      activity: true,
    },
    // place based categories
    {
      id: "home",
      title: "Let's meet at my place",
      tagline: "I can host for regular gatherings",
      details:
        "Available to host regularly at my place for meals, drinks, games, movies, or just to hang out.",
      place: true,
    },
    {
      id: "cafe",
      title: "Let's meet at this cafe",
      tagline: "I've got a great local cafe for regular meets",
      details:
        "I have a lovely local cafe that's perfect for regular catch ups over coffee, tea, snacks, or light meals.",
      place: true,
    },
    {
      id: "studio",
      title: "Let's meet at my studio",
      tagline: "I've got a creative space, workshop, arts hub",
      details:
        "I have a creative studio space that's ideal for regular meets focused on creativity and collaboration.",
      place: true,
    },
    {
      id: "pub",
      title: "Let's meet at this pub",
      tagline: "I've found a great local pub for regular drinks",
      details: "I've discovered a pub that's perfect for catch up drinks.",
      place: true,
    },
    {
      id: "workshop",
      title: "Let's meet at my workshop",
      tagline: "I've got a workshop space for regular builds",
      details:
        "I have a workshop space that's great for regular DIY projects and collaborative builds.",
      place: true,
    },
    {
      id: "gym",
      title: "Let's meet at the gym",
      tagline: "I can host regular fitness sessions",
      details:
        "I have access to a gym where we can have regular fitness sessions together.",
      place: true,
    },
    {
      id: "workspace",
      title: "Let's meet at my workspace",
      tagline: "I've got a co-working space for regular meetings",
      details:
        "I have a co-working space that's perfect for regular work-focused meetings.",
      place: true,
    },
    {
      id: "track",
      title: "Let's meet at the track",
      tagline: "I know a great track for regular runs, cycles",
      details:
        "I have a favorite track ideal for regular running or cycling sessions.",
      place: true,
    },
    {
      id: "stadium",
      title: "Let's meet at the stadium",
      tagline: "I can get us regular spots for sports, concerts",
      details:
        "I can secure regular spots at the local stadium for sports events or concerts.",
      place: true,
    },
    {
      id: "park",
      title: "Let's meet at the park",
      tagline: "I know a great park for regular outdoor meets",
      details:
        "I have a favorite park that's perfect for regular outdoor gatherings and activities.",
      place: true,
    },
    {
      id: "beach",
      title: "Let's meet at the beach",
      tagline: "I know a great beach for regular sun, surf, sand",
      details:
        "I have a favorite beach ideal for regular sunbathing, surfing, or sandcastle building.",
      place: true,
    },
    {
      id: "garden",
      title: "Let's meet at my garden",
      tagline: "I can host regular outdoor gatherings",
      details:
        "I have a lovely garden that's perfect for hosting regular outdoor gatherings and barbecues.",
      place: true,
    },
    {
      id: "rooftop",
      title: "Let's meet at my rooftop",
      tagline: "I can host regular skyline gatherings",
      details:
        "I have a rooftop space with great views, ideal for regular social gatherings.",
      place: true,
    },
    {
      id: "gallery",
      title: "Let's meet at the gallery",
      tagline: "I know a great gallery for regular art meets",
      details:
        "I have a favorite art gallery that's perfect for regular cultural and artistic gatherings.",
      place: true,
    },
  ],
};

export const EventObservables = function (props) {
  return {
    list: ["event", "sharing", "locations", "messaging", "entry"], // must match list of objects that follow next
    event: {
      active: false,
      field: "onDeltaEvent",
      subscription: null,
      modules: [
        "launchpad",
        "sharing",
        "dates",
        "locations",
        "messaging",
        "entry",
      ],
      action: {
        type: props.eventActions.RELOAD_EVENT,
        property: "data",
        recalculate: true,
        recalendar: true,
        reticket: true,
      },
    },
    sharing: {
      active: false,
      field: "onDeltaSharing",
      subscription: null,
      modules: ["sharing"],
      action: {
        type: props.eventActions.PULL_LINKS,
        property: "content",
        recalculate: true,
      },
    },
    locations: {
      active: false,
      field: "onDeltaLocations",
      subscription: null,
      modules: ["locations"],
      action: {
        type: props.eventActions.PULL_PLACES,
        property: "content",
        recalculate: true,
      },
    },
    messaging: {
      active: false,
      field: "onPostChatEventContent",
      subscription: null,
      modules: [
        "launchpad",
        "sharing",
        "dates",
        "locations",
        "messaging",
        "entry",
      ],
      params: { RoomName: "main" },
      action: {
        type: props.eventActions.POST_MESSAGE,
        property: "message",
        recalculate: true,
      },
    },
    entry: {
      active: false,
      field: "onEntryHandshake",
      subscription: null,
      modules: ["entry"],
      action: {
        type: props.eventActions.ENTRY_HANDSHAKE,
        property: "handshake",
      },
    },
  };
};
export const EventPinnedRunnerStates = function () {
  const offerStates = [];
  for (let state of EVENT_CONSTANTS.events.states) {
    if (state.runner) {
      offerStates.push(state.value);
    }
  }
  return offerStates;
};
export const EventPinnedRiderStates = function () {
  const offerStates = [];
  for (let state of EVENT_CONSTANTS.events.states) {
    if (!state.runner) {
      offerStates.push(state.value);
    }
  }
  return offerStates;
};

export const EventTicketOfferStates = function () {
  const offerStates = [];
  for (let state of EVENT_CONSTANTS.tickets.states) {
    if (state.offer) {
      offerStates.push(state.value);
    }
  }
  return offerStates;
};
export const EventTicketLaunchStates = function () {
  const offerStates = [];
  for (let state of EVENT_CONSTANTS.tickets.states) {
    if (state.launch) {
      offerStates.push(state.value);
    }
  }
  return offerStates;
};

export const EventImageFrames = function () {
  const imageFrames = [];
  for (let i = 1; i <= EVENT_CONSTANTS.events.imageFrameCount; i++) {
    let imageFrameBase = JSON.parse(
      JSON.stringify(EVENT_CONSTANTS.events.imageFrameBase)
    );
    imageFrameBase.id = "frame" + i;
    imageFrameBase.order = i;
    imageFrames.push(imageFrameBase);
  }
  // custom frames for special use
  let imageFrameCustom;
  imageFrameCustom = JSON.parse(
    JSON.stringify(EVENT_CONSTANTS.events.imageFrameBase)
  );
  imageFrameCustom.id = "frameCustomSocialBannerOverride";
  imageFrameCustom.order = 101;
  imageFrameCustom.tag = "frameCustom";
  imageFrameCustom.name = "Social banner override";
  imageFrameCustom.description =
    "Use this to override the main banner image posted first in the carousel when boosting on socials. You can set it for different campaigns without affecting any images in the eventuator.";
  imageFrames.push(imageFrameCustom);
  return imageFrames;
};

export const EventSocials = function () {
  return [
    {
      id: "facebook",
      name: "Facebook",
      icon: iconFacebook,
      active: true,
      campaign: null,
    },
    {
      id: "instagram",
      name: "Instagram",
      icon: iconInstagram,
      active: true,
      campaign: null,
    },
    {
      id: "threads",
      name: "Threads",
      icon: iconThreads,
      active: false,
      campaign: null,
    },
    {
      id: "linkedin",
      name: "LinkedIn",
      icon: iconLinkedin,
      active: false,
      campaign: null,
    },
    {
      id: "x",
      name: "X",
      icon: iconX,
      active: true,
      campaign: null,
    },
    {
      id: "youtube",
      name: "YouTube",
      icon: iconYoutube,
      active: false,
      campaign: null,
    },
  ];
};

export default EventMain;

// const holderPositions = {
//   all: ['owner', 'initiated', 'accepted', 'rejected', 'triggered', 'incomplete', 'complete', 'cancelled', 'updating'],
//   unlocked: ['initiated', 'accepted'],
//   locked: ['owner', 'rejected', 'triggered', 'incomplete', 'complete', 'cancelled'],
//   inactive: ['cancelled', 'rejected'],
//   confirmed: ['owner', 'accepted'],
//   billable: ['owner', 'initiated', 'accepted']
// };

// export const RenderTicketState = (props) => {
//   const state = props.state.replace(":", "");
//   const stacked = props.stacked ? true : false;
//   const display = TICKET_STATES.styles[state]
//     ? TICKET_STATES.styles[state].display
//     : "UNAVAILABLE";
//   const icon = TICKET_STATES.styles[state]
//     ? TICKET_STATES.styles[state].icon
//     : "exclamation-square";
//   const spin = TICKET_STATES.styles[state]
//     ? TICKET_STATES.styles[state].spin
//       ? true
//       : false
//     : false;
//   const classtext = TICKET_STATES.styles[state]
//     ? TICKET_STATES.styles[state].classtext
//     : "EntzyLight";
//   const classicon = TICKET_STATES.styles[state]
//     ? TICKET_STATES.styles[state].classicon
//     : "EntzyLight";
//   return (
//     <span className={classtext}>
//       {
//         <FontAwesomeIcon
//           icon={["fas", icon]}
//           spin={spin}
//           className={classicon}
//           transform={stacked ? "grow-10 up-5" : "shrink-2"}
//         />
//       }
//       {stacked ? <br /> : <span>&nbsp;&nbsp;</span>}
//       {display}
//     </span>
//   );
// };
